module.exports = __webpack_public_path__ + "img/padlock.f71af3c4.svg";